import React from "react";
import {headerSortingClasses, sortCaret} from "../../../_metronic/_helpers";
import {useFactorsUIContext} from "./FactorsUIContext";
import * as columnFormatters from "./column-formatters";
import moment from "jalali-moment";
import TableLayout from "../../../_metronic/_partials/controls/table/TableLayout";
import {updateFactorStatus, updateStatus} from "./crud/factorCrud";
import Workbook from 'react-excel-workbook'

export default function FactorsTable({
                                        data,
                                        activePage
                                    }) {

    const factorContext = useFactorsUIContext();

    const handleShowFactor = id => {
        window.location.href='/admin/factors/'+id
    };

    const handleCloseFactor = id => {
        const formData = new FormData();
        formData.append('factor_id', id);
        updateFactorStatus(formData)
            .then(() => {
                factorContext.fetchData();
            })
    }

    const statusColors = {
        1: 'pending',
        2: 'returned',
        4: 'cleared',
        6: 'delivered-to-host',
        8: 'delivered-to-iran',
        10: 'waiting-to-buy',
        12: 'buy-completed',
        14: 'sending-to-iran',
        16: 'canceled',
        17: 'not-available',
    };

    const handleStatusChange = (orderId, statusId) => {
        const formData = new FormData();
        formData.append('order_id', orderId);
        formData.append('status_id', statusId);
        updateStatus(formData)
            .then(() => {
                factorContext.fetchData();
            })
    };

    // Table columns
    const columns = [
        {
            dataField: "priority",
            text: "شماره",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "id",
            text: "شماره فاکتور",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "total_price_lir",
            text: "مبلغ لیر",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "total_price_toman",
            text: "مبلغ تومان",
            style: {minWidth: '7em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "number_of_products",
            text: "تعداد محصولات",
            style: {minWidth: '5em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "factor_date",
            text: "تاریخ ایجاد",
            style: {minWidth: '7em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (date) => {
                if (date) {
                    const createdDate = moment(new Date(date*1000),'YYYY-M-D').format('jYYYY/jMM/jDD ')+' - ' + new Date(date*1000).toLocaleDateString("en-US");
                    return <>{createdDate}</>;
                }
            },
        },{
            dataField: "status",
            text: "وضعیت",
            style: {minWidth: '7em', textAlign: 'center'},
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "action",
            text: "عملیات",
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditPage: handleShowFactor,
                closeFactors:handleCloseFactor
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "9em",
            },
        },
    ];

    return (
        <>
            {!!data.data &&
            <TableLayout activePage={activePage} columns={columns} data={data}/>
            }

        </>
    )
}